'use strict';
import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { EmitterTypes } from '@ispm/layout/constants/emitter-types.enum';
import { EmitType } from '@ispm/layout/constants/emit-types.enum';
import { PasswordEditorMode, PasswordEditorSettings } from '../password-editor-settings';
import {CryptoService} from "@ispm/migration/services/crypto.service";

@Component({
  selector: 'ispm-password-editor-details',
  templateUrl: './password-editor-details.component.html',
  styleUrls: ['./password-editor-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordEditorDetailsComponent  extends PlaceholderChildComponent implements OnInit {
  private formMode: PasswordEditorMode;
  private currentPassword: string;
  private isValid: boolean;
  public formName: string;
  public buttonTitle: string;
  public buttonEnabled: boolean;
  public formData = {};
  public callback: (model) => Observable<Response>;

  constructor(private cryptoService: CryptoService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit()
    this.formMode = this.payload.formMode;
    this.currentPassword = this.payload.password;
    this.formName = this.formMode === PasswordEditorMode.Encrypt ? 'PASSWORD-EDITOR-ENCRYPT' : 'PASSWORD-EDITOR-DECRYPT';
    this.buttonTitle = this.formMode === PasswordEditorMode.Encrypt ? 'Encrypt' : 'Decrypt';
  }

  updateForm(form, updateFieldKeys: any) {
    if (form && updateFieldKeys) {
      this.formData[updateFieldKeys[0]] = form[updateFieldKeys[0]]
    }
    this.buttonEnabled = this.formData['key'] && this.formData['iterationsNum'];
    if (this.formMode === PasswordEditorMode.Encrypt){
      this.buttonEnabled = this.buttonEnabled && this.formData[PasswordEditorSettings.PASSWORD_FIELD_NAME];
    }
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }

  beforeClose() {
    if (this.formMode === PasswordEditorMode.Encrypt && (!this.isValid || !this.formData['result'])){
      return {isValid: false};
    }
    let retObj = {isValid: true};
    if (this.formMode === PasswordEditorMode.Encrypt){
      retObj[PasswordEditorSettings.PASSWORD_FIELD_NAME] = this.formData['result'];
    }
    return retObj;
  }

  submit(model) {
    this.callback(model).subscribe(
      () => {
        this.tunnel$.next({ emitter: EmitterTypes.child, value: EmitType.Dismiss, payload: this.formData})
      });
  }

  Execute(){
    let executed: boolean;

    if (this.formMode == PasswordEditorMode.Encrypt){
      if (this.formData[PasswordEditorSettings.PASSWORD_FIELD_NAME] && this.formData['key'] && this.formData['iterationsNum']){
        this.formData['result'] = this.cryptoService.encrypt(
          this.formData[PasswordEditorSettings.PASSWORD_FIELD_NAME],
          this.formData['key'],
          +this.formData['iterationsNum']
        );
        executed = true;
      }
    }
    else{
      if (this.formData['key'] && this.formData['iterationsNum']){
        this.formData['result'] = this.cryptoService.decrypt(
          this.currentPassword,
          this.formData['key'],
          +this.formData['iterationsNum']
        );
        executed = true;
      }
    }

    if (executed){
      this.formData = cloneDeep(this.formData); //force ui update
      this.currentPassword = this.formData['result'];
    }
  }
}
